import tool from "./tool"

let live = {
    origin: "http://img.fjkankan.com",
    //将聊天信息框的滚动条拉到底部
    toBottom: (id) => {
        let chat = tool.getByID(id);
        chat.appendChild(document.createElement("br"));
        chat.scrollTo(0, document.documentElement.clientHeight);
    },
    //拼接等级图片
    makeLevelImg: (res) => {
        let level = 0; //用户等级标识
        let cStr = res.chatuserinfo.split("-");
        if (cStr.length > 5) {
            level = cStr[2];
            if (level.indexOf("_") == -1) {
                level += "_0";
            }
        } else {
            level = "0";
        }
        return "http://img.fjkankan.com/img/lvv2/lvlv/" + level + ".png";
    },
    //屏幕公告
    warning: (res, id) => {
        let div = document.createElement("div")
        div.classList.add("chat-msg")

        let p = document.createElement("p");
        p.classList.add("common-msg");
        p.innerHTML = res.msg;

        let f = tool.getByID(id);
        div.appendChild(p);
        f.appendChild(div);

        live.toBottom(id);
    },
    //进场
    into: (res, id) => {
        let div = document.createElement("div")
        div.classList.add("chat-msg")

        let p = document.createElement("p");
        p.classList.add("flex-box");
        p.innerHTML = "<img src='" + res.network_level + "' class='level imgBlock noevents-img'/><i class='msg'>欢迎</i> <i class='name'>" + res.nickname + "</i> <i class='msg'>进入房间</i>";

        let f = tool.getByID(id);
        div.appendChild(p);
        f.appendChild(div);

        live.toBottom(id);
    },
    //公共聊天
    say: (res, id) => {
        //分割字符串获取用户发的消息
        
        let msg = res.sendmsg;
        if (msg.indexOf(":") != -1) {
            msg = msg.split("：");
        }else{
            msg = msg.split(/[\s\n]/);
        }
        let div = document.createElement("div")
        div.classList.add("chat-msg")

        let p = document.createElement("p");
        p.classList.add("flex-box");
        p.innerHTML = "<img src='" + res.network_level + "' class='level imgBlock noevents-img'/><i class='name'>" + res.nickname + "：</i> <i class='msg'>" + msg[1] + "</i>";

        let f = tool.getByID(id);
        div.appendChild(p);
        f.appendChild(div);

        live.toBottom(id);
    },

    //接受送礼物信息
    getGift: (res, id) => {

        let div = document.createElement("div")
        div.classList.add("chat-msg")

        let p = document.createElement("p");
        p.classList.add("flex-box");
        p.innerHTML = "<img src='" + res.network_level + "' class='level imgBlock noevents-img'/><i class='name'>" + res.nickname + "</i> <i class='msg'>送给主播" + res.giftnum + "个</i><i class='giftname'>" + res.giftname + "</i>";

        let f = tool.getByID(id);
        div.appendChild(p);
        f.appendChild(div);

        live.toBottom(id);

    },
    //接受公告信息
    getGonggao: (res, id) => {
        let div = document.createElement("div")
        div.classList.add("chat-msg")

        let p = document.createElement("p");
        p.classList.add("common-msg");
        p.innerHTML = res.tip;

        let f = tool.getByID(id);
        div.appendChild(p);
        f.appendChild(div);

        live.toBottom(id);
    }
}

// if (window.location.host == 'test.h5.fjkankan.com') {
//     live.origin = "http://test.wapapi.fjkankan.com";
// } else {
//     live.origin = "https://wap.fjkankan.com";
// }

export default live;